import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ui: {
    footer: 66,
  },
  authView: 'guest',
};

const slice = createSlice({
  name: 'config',
  initialState: initialState,
  reducers: {
    setConfig: (state, { payload }) => payload,
    setUiFooter: (state, { payload }) => ({
      ...state,
      ui: { footer: payload },
    }),
    setAuthView: (state, { payload }) => ({
      ...state,
      authView: payload,
    }),
  },
});

export const { setConfig, setUiFooter, setAuthView } = slice.actions;

export default slice.reducer;

export const selectConfig = (state) => state.config;
